import { AxiosResponse } from 'axios';
import ApiClient from './ApiClient';
import moment from 'moment';

export const getListPaymentMediaOrganization = async (orgCode: string): Promise<any> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const params = { orgCode };

  const response = await ApiClient.get(`/v1/sales/master/paymentMediaOrganization/${companyCode}`, params);
  return response.data;
};

export const deletePaymentMediaOrganization = async (isConfirmed: number,
  paymentMediaOrganization: any): Promise<any> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const params = {
    isConfirmed,
  };

  const response = await ApiClient.post(`/v1/sales/master/paymentMediaOrganization/delete/${companyCode}`, params, paymentMediaOrganization);
  return response.data;
};

export const createOrUpdatePaymentMediaOrganization = async (isCreate: boolean,
  paymentMediaOrganization: any) : Promise<any> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const params = {
    isCreate: isCreate ? 1 : 0,
  };
  const response = await ApiClient.post(`/v1/sales/master/paymentMediaOrganization/${companyCode}`, params, paymentMediaOrganization);
  return response.data;
};

export const getPaymentMediaOrganizationList = async (): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v1/sales/master/paymentMediaRelation/${companyCode}`, {});
  return response.data;
};


export const getPaymentMediaCategoryList = async (): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v1/sales/master/paymentMediaCategory/${companyCode}`, {});
  return response.data;
};


export const downloadCSV = async (fileName: string, orgCode: string): Promise<void> => {

  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  await ApiClient.downloadCsv(`/v3/paymentMediaOrganization/csv/download/${companyCode}?orgCode=${orgCode}`,{}, getDownloadCsvFileName(`${fileName}_`)); 
};
const getDownloadCsvFileName = (prefix: string) => `${prefix}${moment().format('YYYYMMDDHHmmss')}.csv`;

export const importFileCSV = async (uploadFile: File): Promise<AxiosResponse> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const staffName = sessionStorage.getItem('loginUser.staffName') || '';
  const params = {
    createUser: staffName,
    updateUser: staffName,
  };
  const response = await ApiClient.postFile(`/v3/paymentMediaOrganization/csv/import//${companyCode}`, params, 'uploadFile', uploadFile);
  return response;
};

export type Error = {
  error: string;
  defaultMessage: string;
}

export default getListPaymentMediaOrganization;
